<template>
  <div :class="node.isTopOfCard == true ? 'pr-3 pl-4 pt-4 py-1 pb-0' : 'pr-3 pl-1 py-1 pb-0'">
    <v-row
      no-gutters
      class="section-link col-12 pa-0"
      @click.stop="
        openInTab({ pageId: node.id });
        toggleShowSearch(false);
        toggleShowQuickSearch(false);
      "
      :style="node.results.length == 0 && !node.isTopOfCard ? 'opacity:0.7;' : 'opacity:1;'"
    >
      <!-- icon -->
      <v-col class="shrink pr-3">
        <page-type-icon
          :size="node.isTopOfCard == true ? 26 : 22"
          :pageType="node.type"
        ></page-type-icon>
      </v-col>

      <!-- not a result, any location-->
      <v-col
        v-if="node.results == 0"
        class="pt-1 search-result"
        :class="{ 'header pt-1 pb-2 font-weight-medium': node.isTopOfCard == true }"
      >
        <span> {{ node.title }} </span>
      </v-col>

      <!-- A result, top of card (header)-->
      <v-col
        v-else-if="node.isTopOfCard == true"
        class="pt-1 search-result"
        :class="{ 'header pt-1 pb-2 font-weight-medium': node.isTopOfCard == true }"
      >
        <span v-for="(result, index) in node.results" :key="index">
          <span
            v-for="(string, index) in result.highlightString"
            :key="index"
            :class="{
              'pink lighten-4': string.highlight
            }"
            v-text="string.text"
          ></span>
        </span>
        <v-col cols="2" class="flex-grow-0 flex-shrink-0"> </v-col>
      </v-col>

      <!-- A result, contents of card-->
      <v-col v-else class="search-result">
        <v-col class="no gutters col-12 ml-3 pl-1 pa-0">
          <span v-for="(result, index) in node.results" :key="index">
            <span
              v-for="(string, index) in result.highlightString"
              :key="index"
              :class="{ 'pink lighten-4': string.highlight }"
              v-text="string.text"
            ></span> </span
        ></v-col>
      </v-col>

      <!-- Here are the location icons -->

      <!-- <span v-if="node.locations[0].rootType == 'archive'">
        <oh-v-icon name="nd-archive"></oh-v-icon>
      </span> -->
      <!-- <user-avatar
        v-for="avatar in node.locations"
        :key="avatar.userid"
        size="25px"
        class="grey lighten-4 mr-1"
        :avatarUrl="avatar.avatarUrl"
      ></user-avatar> -->

      <span v-for="avatar in node.locations" :key="avatar.userId">
        <span v-if="avatar.rootType == 'panel'">
          PANEL
          <user-avatar size="25px" class="mr-1" :avatarUrl="avatar.avatarUrl"></user-avatar>
        </span>
        <span v-else-if="avatar.rootType == 'archive'">
          ARCHIVED
          <oh-v-icon size="25px" style="color:grey" class="mr-1" name="md-archive"></oh-v-icon>
        </span>
        <span> </span>
      </span>
      <v-divider v-if="node.isTopOfCard == true" class="col-12 py-1"></v-divider>
    </v-row>

    <!-- children -->
    <div
      v-if="node.children.length > 0"
      class="no gutters col-12 ml-3 pl-1 pa-0"
      :style="
        node.depth > 1
          ? 'border-left: 2px solid #efefef; border-radius: 0px; width: 100%'
          : 'border-left: 0px'
      "
    >
      <result-node
        v-for="child in node.children"
        v-bind:key="child.order"
        :node="child"
        :rootID="rootID"
      >
      </result-node>
    </div>
    <div class="pl-8">
      <div
        v-for="(child, index) in resultChildren"
        :key="index"
        style="opacity:0.7; display: inline;"
      >
        <page-type-icon :size="16" :pageType="child.type" style="display: inline;"></page-type-icon>
        <span class="caption pr-1">
          {{ child.title.slice(0, 25) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
// import PageTypeIcon from '@/components/ContextDoc/PageTypeIcon';
import useWorkspace from '@/views/Context/use/useWorkspace';
import useSearch from '@/views/Context/use/useSearch';
import UserAvatar from '@/components/UserAvatar.vue';

export default {
  components: { UserAvatar },
  name: 'ResultNode',
  props: {
    node: Object,
    rootID: String,
    maxChildren: {
      default: 2,
      type: Number
    },
    components: {}
  },

  setup(props) {
    let resultChildren = [];
    const maxChildrenToShow = 2;
    if (props.node.results.length > 0 && props.node.children == 0) {
      props.node.results[0].children.forEach((child, index) => {
        if (index < maxChildrenToShow) {
          resultChildren.push(child);
        }
      });
    }
    const { showSearch, toggleShowSearch, toggleShowQuickSearch } = useSearch();
    const { openInTab } = useWorkspace();
    return { openInTab, showSearch, toggleShowSearch, toggleShowQuickSearch, resultChildren };
  }
};
</script>

<style>
.search-result.header {
  font-size: 17px !important;
  font-weight: 300;
}

.search-result {
  font-size: 14px !important;
}
</style>
